import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StringService } from 'src/app/services/string.service';

@Component({
  selector: 'app-cancel-dialog',
  templateUrl: './cancel-dialog.component.html',
  styleUrls: ['./cancel-dialog.component.scss']
})
export class CancelDialogComponent implements OnInit {

  public title = 'Message';
  public description = 'Please contact us on +61 9302 2888 as your appointment is within 24hrs and a cancellation fee applies.';
  public confirmText = 'Yes';
  public textAreaHint = 'Comment';
  public textAreaValue = '';

  constructor(
    public dialogRef: MatDialogRef<CancelDialogComponent>,
    public stringService: StringService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    if (this.data != null) {
      if (this.stringService.isNotEmpty(this.data.title)) {
        this.title = this.data.title;
      }

      if (this.stringService.isNotEmpty(this.data.description)) {
        this.description = this.data.description;
      }

      if (this.stringService.isNotEmpty(this.data.confirmText)) {
        this.confirmText = this.data.confirmText;
      }

      if (this.stringService.isNotEmpty(this.data.textAreaHint)) {
        this.textAreaHint = this.data.textAreaHint;
      }

      if (this.stringService.isNotEmpty(this.data.textAreaValue)) {
        this.textAreaValue = this.data.textAreaValue;
      }
      
      if (this.data.appointment.hoursBeforeAppointment > 24) {
        this.description = "Are you sure you want to delete your appointment?";
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.data.action = 1;
    this.dialogRef.close(this.data);
  }

}
